import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const TitleBase = styled.div`
  ${typographyV2.titleBase};
  margin-bottom: 8px;
`;

export const BodySmall = styled.div`
  ${typographyV2.bodySm};
  margin-bottom: 12px;
`;

export const HorizontalDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: var(--border-soft);
`;

export const SectionRow = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
`;

export const CompetitorsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const loadingSkeletonAreas = [
  {
    styles: {
      width: '100%',
      height: '180px',
      borderRadius: '8px',
    },
  },
];
